<template>
    <div class="trip-date-picker" v-bind="$attrs" @click="datePicker.show()">
        <input v-show="!inline" type="text"
               id="date-picker"
               name="dates"
               autocomplete="off"
               placeholder="Add trip dates (optional)" />
        <button v-show="!inline" class="clear" @click="clear()" v-if="isDirty">
            <svg class="close"><use xlink:href="#close"></use></svg>
        </button>
    </div>
</template>
<script>
const lightPick = require('lightpick');

export default {

    props: {
        value: {
            required: false,
            default: null,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data() {
        return {
            form: this.value,
            datePicker: null,
        }
    },

    mounted() {
        this.createDatePicker()
    },

    created(){
        this.$nextTick(() => {
            this.setInitialDates()
        })
    },

    methods: {

        /**
         * Create the date picker.
         */
        createDatePicker() {

            let settings = {
                field: document.getElementById('date-picker'),
                singleDate: false,
                inline: this.inline,
                format: 'MMM DD YYYY',
                onSelect: (start, end) => {

                    if (start && end) {
                        this.setDates(start, end)
                        return;
                    }
                    this.form.trip_date = null
                    this.form.trip_days = null
                    this.$emit('input', this.form)
                }
            }

            if(this.form.trip_date && this.form.trip_days) {
                let start = moment(this.form.trip_date).utc()
                let end = start.add((this.form.trip_days - 1), 'days')
                settings.startDate = start.startOf('day')
                settings.endDate = end.endOf('day').diff(start, 'days') + 1
            }
            this.datePicker = new lightPick(settings)
        },

        setInitialDates() {
            if (this.form.trip_date && this.form.trip_days) {
                let end = moment(this.form.trip_date).utc().add((this.form.trip_days - 1), 'days')
                this.datePicker.setDateRange(moment(this.form.trip_date).utc(), end)
            }
        },

        /**
         * Set start date and number of days.
         */
        setDates(start, end) {
            this.form.trip_date = start.startOf('day').format('YYYY-MM-DD')
            this.form.trip_days = end.endOf('day').diff(start, 'days') + 1
            this.$emit('input', this.form)
        },

        /**
         * Clear dates
         */
        clear() {
            this.datePicker.reset()
            this.form.trip_date = null
            this.form.trip_days = null
            this.$emit('input', this.form)
        }
    },

    watch:{
        value:{
            deep: true,
            handler(){
                this.form = this.value
                if (this.form.trip_date == null && this.form.trip_days == null) {
                    this.clear()
                }else{
                    this.setInitialDates()
                }
            }
        }
    },

    computed: {
        isDirty() {
            return this.form.trip_date != null && this.form.trip_days != null;
        }
    }
}
</script>
